import React, { useMemo } from 'react'
import { useIntl } from 'react-intl'

import { formatPrice } from 'utils'
import { FloatingPriceWrapper } from 'components/FloatingPrice'
import { useCartDeliveryAddress, isAnyFloatingPriceInCart } from '../utils'
import Content from './Content'
import PlaceOrderRow from './PlaceOrderRow'

import messages from '../messages'

const SummaryBoxDesktop = ({ userData, cartData }) => {
  const { formatMessage } = useIntl()

  const { totalPrice } = cartData
  const { customerName, paymentMethodCode, paymentTermCode } = userData

  const addressFormatted = useCartDeliveryAddress(userData)
  const hasFloatingPrice = useMemo(() => isAnyFloatingPriceInCart(cartData), [
    cartData,
  ])

  return (
    <div className="flex flex-col gap-6">
      <div
        data-test-id="cart_user-details"
        className="flex flex-col p-5 pb-0 gap-5"
      >
        <div className="flex flex-col py-2">
          <p className="text-label-11md">{customerName}</p>
          <p className="text-label-11 text-grey-800">{addressFormatted}</p>
        </div>
        <div className="flex flex-col">
          <p className="text-label-11 text-grey-800">
            {formatMessage(messages.payment)}
          </p>
          <p className="text-label-11md capitalize">{`${paymentMethodCode}, ${paymentTermCode}`}</p>
        </div>
      </div>
      <div className="flex flex-col rounded-[20px] p-5 bg-white gap-6 w-[300px] shadow-[0px_10px_10px_-8px_#00000026] h-fit">
        <Content userData={userData} cartData={cartData} isDesktop />
        <PlaceOrderRow cartData={cartData}>
          <div className="flex flex-col gap-0.5 items-end">
            <span className="text-14 leading-6">
              {formatMessage(messages.totalGross)}
            </span>
            <FloatingPriceWrapper
              hasTooltip
              tooltipMsg={formatMessage(messages.floatingPriceText)}
              hasFloatingPrice={hasFloatingPrice}
              containerStyle={{ alignItems: 'baseline' }}
            >
              <span className="text-[28px] leading-10 font-medium">
                {formatPrice(totalPrice.gross)}
              </span>
            </FloatingPriceWrapper>
          </div>
        </PlaceOrderRow>
      </div>
    </div>
  )
}

export default SummaryBoxDesktop
